import React from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
;

// Need to put the id in this paramater, and put it in the triggerUpdateInparent first paramter, not on the field itself
export default function Checkbox_Regular(props) {
  const [state, setState] = React.useState({
    checked: props.valueInField
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
    if (props.updateValueInParent){
      props.updateValueInParent(event.target.checked)
    }
  };

  const handleClick = (event) =>{
    if (props.triggerUpdateInParent){
      props.triggerUpdateInParent(props.id, event.target.checked)
    }
    
  }

  return (
    <FormGroup row>
      {props.required ? <span className="required-field-checkbox">*</span> : <span className="unrequired-field">*</span>}
      <FormControlLabel
        control={
          <Checkbox
            checked={state.checked}
            onChange={handleChange}
            onClick={handleClick}
            name="checked"
            color="primary"
          />
        }
        label={props.label}
      />
      
    </FormGroup>
    
  );
}
